export default __webpack_public_path__ + "static/media/adding_prospects_step2.0512ad00.png";